export default __webpack_public_path__ + "static/media/USAevacuation.c1144a02.jpg";